// .env constants
const {
    REACT_APP_ENV,
    REACT_APP_VERSION,

    REACT_APP_APP_NAME,
    REACT_APP_URL,
    REACT_APP_API_URL,

    REACT_APP_SENTRY_DSN,
    REACT_APP_GOOGLE_MAPS_KEY,
    REACT_APP_ENABLE_FREE_PREMIUM,
} = process.env;

// APP CONSTANTS
const app = {
    ENV: REACT_APP_ENV,
    VERSION: REACT_APP_VERSION || '0.0.0',
    DEBUG: REACT_APP_ENV === 'local',
    MOCK: false,
    BACKEND: 'laravel', // or 'yii'

    APP_NAME: REACT_APP_APP_NAME || 'Prakash Astrologer',

    APP_URL: REACT_APP_URL,
    API_URL: REACT_APP_API_URL,

    SENTRY_DSN: REACT_APP_SENTRY_DSN,
    GOOGLE_MAPS_KEY: REACT_APP_GOOGLE_MAPS_KEY,

    AUTH_KEY: 'auth-key',
    LOCALSTORAGE_EXPIRES_KEY: 'session-token-expiry',
    LOCALSTORAGE_EXPIRES_TIME: '30', // minutes

    // Feature flags
    ENABLE_FREE_PREMIUM: REACT_APP_ENABLE_FREE_PREMIUM === 'true',
};

export default app;
